// extracted by mini-css-extract-plugin
module.exports = {"card":"_f8ae55","logoContainer":"_b7cde7","logo":"_37d22a","info":"_2bfff6","listingName":"_12ad33","productName":"_2759ae"};